<template>
	<v-expansion-panel v-if="interaction && canView">
		<v-expansion-panel-header :hide-actions="true" :color="headerColor">
			<v-row no-gutters>
				<v-col class="ma-auto">
					Interaction {{ currentInteraction.Index }}
				</v-col>
				<v-col>
					<v-btn
						v-if="canDelete"
						fab
						small
						icon
						elevation="2"
						class="action-btn float-right"
						@click.stop="remove()"
					>
						<v-icon color="error" small>mdi-delete</v-icon>
					</v-btn>
					<v-btn
						v-if="showSaveButton"
						fab
						small
						icon
						elevation="2"
						class="action-btn float-right"
						@click.stop="submit(index)"
					>
						<v-icon color="primary" small> mdi-content-save</v-icon>
					</v-btn>
				</v-col>
			</v-row>
		</v-expansion-panel-header>
		<v-expansion-panel-content>
			<v-form ref="form" :disabled="!disableForm">
				<div style="display: flex; flex-direction: row">
					<!-- <v-col>
                        <div>
                            <h4 class="mb-1">Triggers</h4>
                            <v-checkbox
                                v-model="interaction.OnLoad"
                                hide-details="true"
                                class="mt-0 pt-0"
                                label="On Load"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="interaction.OnChange"
                                hide-details="true"
                                class="mt-0 pt-0"
                                label="On Change"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="interaction.OnFocus"
                                hide-details="true"
                                class="mt-0 pt-0"
                                label="On Focus"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="interaction.OnBlur"
                                hide-details="true"
                                class="mt-0 pt-0"
                                label="On Blur"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="interaction.OnKeyPress"
                                hide-details="true"
                                class="mt-0 pt-0"
                                label="On Key press"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="interaction.RevertOnOppositeTrigger"
                                hide-details="true"
                                class="mt-0 pt-0"
                                label="Revert on opposite trigger"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="interaction.RevertOnOppositeValue"
                                hide-details="true"
                                class="mt-0 pt-0"
                                label="Revert on opposite value"
                            ></v-checkbox>
                        </div>
                    </v-col> -->
					<v-col>
						<div>
							<h4>Conditions</h4>
							<form-condition
								:ref="'formCondition_' + index"
								v-for="(
									condition, index
								) in interaction.Conditions"
								:condition="interaction.Conditions[index]"
								:index="index"
								:key="index"
								:newInteraction="currentInteraction.IsNew"
								@remove="removeCondition(index)"
							/>
							<v-btn
								v-if="
									(canEdit &&
										currentInteraction.IsNew == false) ||
									(canAdd && currentInteraction.IsNew == true)
								"
								small
								class="primary"
								width="100%"
								@click="addCondition()"
							>
								Add new condition
							</v-btn>
						</div>
					</v-col>
					<v-col
						><div><h4>Actions</h4></div>
						<form-action
							:ref="'formAction_' + index"
							v-for="(action, index) in interaction.Actions"
							:key="index"
							:index="index"
							:action="interaction.Actions[index]"
							:newInteraction="currentInteraction.IsNew"
							@remove="removeAction(index)"
						/>
						<v-btn
							v-if="
								(canEdit &&
									currentInteraction.IsNew == false) ||
								(canAdd && currentInteraction.IsNew == true)
							"
							small
							class="primary"
							width="100%"
							@click="addAction()"
						>
							Add new action
						</v-btn>
					</v-col>
				</div>
			</v-form>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>
<script>
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import FormCondition from './FormCondition.vue';
import FormAction from './FormAction.vue';
import { InteractionsActions } from '../../../../store/actions';
import { Permissions } from '../../../../enums/permissionsEnum';
import permissionsMixin from '../../../../mixins/permissionsMixin';
export default {
	name: 'FormInteraction',
	components: { FormCondition, FormAction },
	mixins: [permissionsMixin],
	props: {
		index: Number,
		currentInteraction: Object,
	},
	computed: {
		disableForm() {
			return (
				(this.canEdit && this.currentInteraction.IsNew == false) ||
				(this.canAdd && this.currentInteraction.IsNew == true)
			);
		},
		canAdd() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Add,
			]);
		},
		canEdit() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Edit,
			]);
		},
		canView() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.View,
			]);
		},
		canDelete() {
			return this.hasPermissions([
				Permissions.Tools.FormBuilder.Interactions.Delete,
			]);
		},
		showSaveButton() {
			if (this.canAdd && this.interaction.IsNew === true) return true;
			if (this.canEdit && this.interaction.IsNew === false) return true;
			return false;
		},
		headerColor() {
			if (this.hasChanges) return '#ffc00030';
			return '#ffffff';
		},
	},
	watch: {
		interaction: {
			handler: function () {
				if (!this.interaction) this.hasChanges = false;
				if (!this.currentInteraction) this.hasChanges = false;
				let changes = this.getChanges(
					[this.currentInteraction],
					[this.interaction]
				);
				this.hasChanges = changes.length > 0;
			},
			deep: true,
		},
	},
	data() {
		return {
			interaction: null,
			hasChanges: true,
		};
	},
	mounted() {
		if (this.currentInteraction) {
			this.interaction = JSON.parse(
				JSON.stringify(this.currentInteraction)
			);
		}
	},

	methods: {
		getChanges(oldArray, newArray) {
			var changes, i, item, j, len;
			if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
				return false;
			}
			changes = [];
			for (i = j = 0, len = newArray.length; j < len; i = ++j) {
				item = newArray[i];
				if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
					changes.push(item);
				}
			}
			return changes;
		},
		addCondition() {
			this.interaction.Conditions.push(
				Object.assign(
					{},
					{ DataFieldId: null, Operator: 0, Value: null }
				)
			);
		},
		removeCondition(index) {
			this.interaction.Conditions.splice(index, 1);
		},
		addAction() {
			this.interaction.Actions.push(
				Object.assign(
					{},
					{ DataFieldId: null, Value: 1, Comment: null }
				)
			);
		},
		removeAction(index) {
			this.interaction.Actions.splice(index, 1);
		},

		validate() {
			let valid = true;
			this.interaction.Conditions.forEach((e) => {
				var index = this.interaction.Conditions.indexOf(e);
				if (this.$refs['formCondition_' + index]) {
					let conditionValid =
						this.$refs['formCondition_' + index][0].validate();
					valid = valid && conditionValid;
				}
			});
			this.interaction.Actions.forEach((e) => {
				var index = this.interaction.Actions.indexOf(e);
				if (this.$refs['formAction_' + index]) {
					let conditionValid =
						this.$refs['formAction_' + index][0].validate();
					valid = valid && conditionValid;
				}
			});
			return valid;
		},

		submit() {
			if (!this.validate()) return;

			let interactionToSubmit = Object.assign(
				{},
				{
					Actions: this.interaction.Actions,
					Conditions: this.interaction.Conditions,
					Interaction: {
						InventoryId: this.interaction.InventoryId,
						Order: this.interaction.Order,
						Id: this.interaction.Id,
					},
					OnBlur: this.interaction.OnBlur,
					OnChange: this.interaction.OnChange,
					OnFocus: this.interaction.OnFocus,
					OnKeyPress: this.interaction.OnKeyPress,
					OnLoad: this.interaction.OnLoad,
					RevertOnOppositeTrigger:
						this.interaction.RevertOnOppositeTrigger,
					RevertOnOppositeValue:
						this.interaction.RevertOnOppositeValue,
				}
			);

			let action = InteractionsActions.ADD;
			if (this.interaction.Id) {
				action = InteractionsActions.UPDATE;
			}

			this.$store
				.dispatch(action, interactionToSubmit)
				.then(({ success, data }) => {
					if (success === false) return;
					if (data) {
						this.interaction = data;
					}
					this.interaction.IsNew = false;
					this.hasChanges = false;
					this.interaction.Index = this.currentInteraction.Index;
					this.$emit('saved', {
						oldItem: this.currentInteraction,
						newItem: JSON.parse(JSON.stringify(this.interaction)),
					});
				});
		},

		remove() {
			ConfirmDialog({
				message: 'Are you sure you want to delete this interaction?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$emit('remove', this.currentInteraction);
				}
			});
		},
	},
};
</script>
<style scoped>
.indexCol {
	max-width: 35px;
}
.actionCol {
	max-width: 100px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: flex-end;
}
</style>
